import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { QRCodeCanvas } from "qrcode.react";

type FormRow = {
  token: string;
  welcome_message: string | null;
  brand_image_url: string | null;
};
type EventRow = { title: string; start_at: string | null; location: string | null };

export default function EventQRPrint() {
  const { id } = useParams();
  const [ev, setEv] = useState<EventRow | null>(null);
  const [form, setForm] = useState<FormRow | null>(null);

  const url = useMemo(
    () => (form?.token ? `${window.location.origin}/e/${form.token}` : ""),
    [form]
  );

  useEffect(() => {
    (async () => {
      if (!id) return;
      const { data: e } = await supabase
        .from("events")
        .select("title,start_at,location")
        .eq("id", id)
        .maybeSingle();
      setEv(e as any);

      const { data: f } = await supabase
        .from("event_forms")
        .select("token,welcome_message,brand_image_url")
        .eq("event_id", id)
        .maybeSingle();
      setForm(f as any);
    })();
  }, [id]);

  function goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else if (id) {
      window.location.href = `/events/${id}`;
    } else {
      window.location.href = `/events`;
    }
  }

  return (
    <div style={page}>
      {/* Controls bar (hidden on print) */}
      <div style={toolbar} className="no-print">
        <button onClick={goBack} style={linkBtn} title="Back">
          ← Back
        </button>
        <div style={{ flex: 1 }} />
        <button className="no-print" onClick={() => window.print()} style={printBtn}>
          Print
        </button>
      </div>

      {form?.brand_image_url && (
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <img
            src={form.brand_image_url}
            alt="Brand"
            style={{ maxWidth: 320, maxHeight: 160 }}
          />
        </div>
      )}

      <h1 style={{ margin: 0, textAlign: "center", fontSize: "2.2rem" }}>
        {ev?.title ?? "Event"}
      </h1>
      {(ev?.start_at || ev?.location) && (
        <div style={{ textAlign: "center", marginTop: 6, marginBottom: 12 }}>
          {ev?.start_at ? new Date(ev.start_at!).toLocaleString() : ""}
          {ev?.location ? ` • ${ev.location}` : ""}
        </div>
      )}

      <div style={{ display: "grid", justifyItems: "center", marginTop: 12 }}>
        {url ? (
          <QRCodeCanvas value={url} size={320} />
        ) : (
          <div>No check-in link yet.</div>
        )}
        <div style={{ marginTop: 10, fontSize: 14, wordBreak: "break-all" }}>
          {url}
        </div>
      </div>

      {form?.welcome_message && (
        <div style={{ marginTop: 18, fontSize: 18, textAlign: "center" }}>
          {form.welcome_message}
        </div>
      )}
    </div>
  );
}

const page: React.CSSProperties = {
  padding: 24,
  maxWidth: 794,
  margin: "0 auto",
  fontFamily: "ui-sans-serif, system-ui",
};
const toolbar: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 12,
};
const linkBtn: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  background: "#fff",
  cursor: "pointer",
};
const printBtn: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  background: "#fff",
  cursor: "pointer",
};
